<script>
export default {
  props: {
    infoList: {
      type: Array,
      default: () => {
        return [
          {
            type: 'text', // [text, tag]
            title: '報名時間',
            text: '2021/08/26~2022/10/02',
            class: '',
            titleClass: '',
            textClass: '',
            condition: () => {
              return true
            },
          },
        ]
      },
    },
  },
}
</script>

<template>
  <ul :class="$style.listInfo">
    <template v-for="(infoItem, index) in infoList">
      <li :key="`infoList-${index}`" :class="infoItem.class" class="listInfo__item">
        <span :class="infoItem.titleClass" class="listInfo__title" v-html="infoItem.title"></span>
        <template v-if="!infoItem.type || infoItem.type === 'text'">
          <span :class="infoItem.textClass" class="listInfo__text" v-html="infoItem.text"></span>
        </template>
        <template v-if="infoItem.type === 'tag'">
          <span>
            <el-tag :class="infoItem.textClass" v-html="infoItem.text"></el-tag>
          </span>
        </template>
      </li>
    </template>
  </ul>
</template>
<style lang="scss" module>
.listInfo {
  @include list-unstyled;

  :global {
    .listInfo {
      &__item {
        display: flex;
        flex-direction: column;

        &:not(:last-child) {
          margin-bottom: 1.5rem;
        }
      }

      &__title {
        margin-bottom: 0.5rem;
        font-size: 1.25rem;
        font-weight: 500;
        @include max-md {
          font-size: 1rem;
        }
      }

      &__text {
        font-size: 0.875rem;
        color: $color-gray-7;

        a {
          color: $color-gray-7;

          &:hover {
            color: $color-primary;
            text-decoration: none;
          }
        }
      }
    }
  }
}
</style>
